import { safeArray } from "@/helpers/functions/ArrayHelpers";
import moment from "moment";

export function useLastCommit() {
  const base = String(process.env.VUE_APP_LAST_COMMIT);
  const $isHMG = String(process.env.VUE_APP_DEPLOY_ENV) !== "PROD";
  const $isProd = String(process.env.NODE_ENV) === "production";

  const dateFormat = "ddd MMM DD HH:mm:ss YYYY ZZ";
  const parsedDateFormat = "DD/MM/YYYY hh:mm";
  const matchHash = /^commit\s+(\S+)$/m;
  const commitTabsRgx = /^\s{4}/gm;
  const matchAuthor = /^Author:\s+(.+)$/m;
  const matchDate = /^Date:\s+(.+)$/m;
  const matchCommit = /^Date:.*\r?\n\r?\n([\s\S]*)$/m;

  const [, hash = ""] = safeArray(base.match(matchHash));
  const [, author = ""] = safeArray(base.match(matchAuthor));
  const [, date = ""] = safeArray(base.match(matchDate));
  const [, commit = ""] = safeArray(base.match(matchCommit));
  const trimedDate = date.trim();

  const parsedDate = moment.parseZone(trimedDate, dateFormat, "en", true);

  return {
    $isHMG,
    $isProd,
    $isValid: !!base,

    author: author.trim(),
    commit: commit.replace(commitTabsRgx, "").trim(),
    date: parsedDate.format(parsedDateFormat),
    hash: hash.trim(),
    isValidDate: parsedDate.isValid(),
    raw: base,
  };
}
